/*
* Accommodation filter
*
*/
jQuery(document).ready(function($) {
    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('state');
    let stateParamValue = '';

    $("#accommodation-tax-state").each(function () {
        $('option.accommodation-state', this).each(function () {
            if ($(this).text()?.toLowerCase() == stateParam?.toLocaleLowerCase()) {
                stateParamValue = $(this).val();
            }
        });
    });

    let ajaxUrl = ajax_callback_data.ajax_url;
    let ajaxNonce = ajax_callback_data.ajax_nonce;

    /* accommodation category click */
    $(document).on('click', '.category-item', function() {
        let accommodationCategory = $(this).attr('id');
        $('.category-item').removeClass('active');
        $(this).addClass('active');
        // $('#accommodation_cat').val(accommodationCategory);
        let perPage = $('#accommodation_per_page').data('perpage');
        $('#accommodation_per_page').val(perPage);
        $('#accommodation_more').val('');
        $('#accommodation-filter-form').submit();
    });

    /* accommodation load more */
    $(document).on('click', '#accommodation-load-more', function() {
        // set filter method is load more
        $('#accommodation_more').val('more');
        $('#accommodation-filter-form').submit();
    });

    /* input submit */
    $(document).on('click', '.accommodation-filter-submit', function(e) {
        e.preventDefault();
        $('#accommodation_more').val('');
        let perPage = $('#accommodation_per_page').data('perpage');
        $('#accommodation_per_page').val(perPage);
        $('#accommodation-filter-form').submit();
    });

    /* reset filter */
    $(document).on('click', '.accommodation-filter-reset', function(e) {
        e.preventDefault();
        $('#accommodation_more').val('');
        // $('#accommodation_cat').val('');
        $('#accommodation-tax-cat').val('').trigger('change');
        $('#accommodation-tax-state').val('').trigger('change');
        // $('#accommodation-tax-city').val('').trigger('change');
        $('#accommodation-tax-suburb').val('').trigger('change');
        $('.accommodation-category .category-item').each(function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        });
        $('#accommodation_total').val('');
        let perPage = $('#accommodation_per_page').data('perpage');
        $('#accommodation_per_page').val(perPage);
        $('#accommodation_total').val(perPage);
        $('#accommodation-filter-form').submit();
    });

    /*******************************
    * Accommodation filter submit
    *******************************/    
    $('#accommodation-filter-form').submit(function(e) {
        e.preventDefault();
        
        let formdata = $('#accommodation-filter-form').serialize();
        let form_data = new FormData();
        form_data.append('frmdata', formdata?.includes('accommodation_state') ? formdata : `${formdata}&accommodation_state=${stateParamValue}`);
        form_data.append('accommodation-filter-nonce', ajaxNonce);

        let perPage = $('#accommodation_per_page').val();
        $('#accommodation_total').val(perPage);

        let loadMore = $('#accommodation_more').val();
        if( loadMore == 'more' ) {
            let more = $('#accommodation_per_page').data('more');
            let totalPost = Number(perPage) + Number(more);
            $('#accommodation_total').val(totalPost);
            
            form_data.append('additional', more);
            form_data.append('load-more', totalPost);
        }

        $.ajax({
            url: ajaxUrl + '?action=accommodation_filter',
            xhrFields: {
                withCredentials: true
            },
            data: form_data,
            type: 'POST',
            datatype: 'HTML',
            processData: false,
            contentType: false,
            beforeSend: function() {
                if( loadMore == 'more' ) {
                    $('.accommodation-post-more').before(ajaxLoading);
                } else {
                    ajaxLoaderShow();
                }
                $('.accommodation-post-more').hide();
            },
            success: function(response) {
                let $html = response.data.html;

                let foundPosts = Number(response.data.found_posts);

                totalPost = $('#accommodation_total').val();
                if( loadMore == 'more' ) {
                    $('.accommodation-filter__results .row').append($html);
                    $('#accommodation_per_page').val(totalPost);
                } else {
                    $('.accommodation-filter__results').empty();
                    $('.accommodation-filter__results').html($html);
                }
                
                if( foundPosts <= totalPost ) {
                    $('.accommodation-post-more').hide();
                } else {
                    $('.accommodation-post-more').show();
                }
            },
            complete: function() {
                if( loadMore == 'more' ) {
                    $('.btn-loading').remove();
                } else {
                    ajaxLoaderHide();
                }
            },
        });
            
    });

});